import { useState, useRef, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { Link, useLocation } from 'react-router-dom';
import PerfilMatrimonioForm from '../components/perfil/PerfilMatrimonioForm';
import PerfilMamaForm from '../components/perfil/PerfilMamaForm';
import DireccionForm from '../components/perfil/DireccionForm';
import PerfilAsesorForm from '../components/perfil/PerfilAsesorForm';
import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";
import { getALlowedSections, updateMembership, userRegister } from '../controllers/user';
import Loading from '../components/loading/Loading';
import PerfilApostoladoForm from '../components/perfil/PerfilApostoladoForm';
import { fetchClientSecret, submitMembershipOrder } from '../controllers/orders';
import { useAuth } from '../components/auth/AuthProvider';
import { getMembershipProducts } from '../controllers/products';
import { stripeKey } from '../controllers/config';
import {loadStripe} from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import PerfilPermisosForm from '../components/perfil/PerfilPermisos';
import { useToast } from '../components/toast/ToastContext';
const stripePromise = loadStripe(stripeKey);

function Registro() {
  const [membresias, setMembresias] = useState([]);
  const [paso, setPaso] = useState(0);
  const [membresia, setMembresia] = useState();
  const [perfil, setPerfil] = useState({});
  const [direccion, setDireccion] = useState({});
  const [consents, setConsents] = useState([]);
  const [apostolado, setApostolado] = useState({});
  const [orderId, setOrderId] = useState('');
  const [onApproveMessage, setOnApproveMessage]  =useState('');
  const [onErrorMessage, setOnErrorMessage] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userId, setUserId] = useState();
  const [loading, setLoading] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [pagoCompleted, setPagoCompleted] = useState(false);
  const [confirmedApostolado, setConfirmedApostolado] = useState(false);
  const showToast = useToast();

  const perfilRef = useRef();
  const direccionRef = useRef();
  const apostoladoRef = useRef();
  const consentRef = useRef();

  const { onLogin, token, onLogout, onCompleteRegistration } = useAuth();

  let contenido;
  let acciones;
  const location = useLocation();

  useEffect(() => {
    document.title = 'FAMA - Registro';
    loadMemberships();
  }, []);
  useEffect(() => {
    const membershipFromApi = location?.state?.membership;
    if (membershipFromApi) {
      const m = membresias.filter(m => m.profileType === membershipFromApi.profile_type_id)[0];
      if (m) {
        setUserId(membershipFromApi.user_id);
        setMembresia(m);
        setApostolado({
          region: membershipFromApi.region_id,
          diocesis: membershipFromApi.diocesis_id,
          comunidad: membershipFromApi.comunidad_id,
          etapa: membershipFromApi.etapa
        });
        if (location.state.confirmNewMembership) {
          gotoPaso(3);
        }
        else {
          gotoPaso(6);
        }
      }
    }
  }, [membresias]);

  useEffect(() => {
    if (error) {
      showToast({
        message: error,
        bg: 'danger',
        autohide: true,
        delay: 9000,
        title: 'Error de registro'
      });
    }
  }, [error]);

  useEffect(() => {
    if (success) {
      showToast({
        message: success,
        bg: 'success',
        autohide: true,
        delay: 9000,
        title: 'Registro exitoso'
      });
    }
  }, [success]);

  useEffect(() => {
    console.log('Submitting apostolado info: ', apostolado);
    if (apostolado && location?.state?.confirmNewMembership && apostolado.apostoladoNacional != undefined) {
      // Submit apostolado to API to update the pending membership and go to payment.
      // if form has been submitted then update apostolado.
      console.log('Submitting apostolado info: ', apostolado);
      submitApostoladoUpdate().then(() => {
        gotoPaso(6);
      });
    }
  }, [apostolado]);

  async function loadMemberships() {
    let products = await getMembershipProducts();
    setMembresias(products);
  }

  function siguientePaso() {
    console.log('siguiente paso.');
    let allowGoToNext = false;
    let errorMessage = '';
    switch(paso) {
      case 1: setPerfil(perfilRef.current.getPerfil()); break;
      case 2: setDireccion(direccionRef.current.getDireccion()); break;
      case 3: 
        errorMessage = apostoladoRef.current.validate();
        if (!errorMessage) {
          setApostolado(apostoladoRef.current.getApostolado()); 
        }
        break;
      case 4: setConsents(consentRef.current.getPermisos()); break;
    }
    console.log('Error message: ' + errorMessage);
    if (!errorMessage) {
      setError('');
      setPaso(paso + 1);
    }
    else {
      setError(errorMessage);
    }
  }
  function pasoAnterior() {
    setPaso(paso - 1);
  }
  function gotoPaso(paso) {
    setPaso(paso);
  }

  async function submitApostoladoUpdate() {
    let p = apostolado;
    const membershipFromApi = location?.state?.membership;
    console.log('membership from api', membershipFromApi);
    p.ciclo = membershipFromApi.ciclo;
    p.profileType = membershipFromApi.profile_type_id;
    console.log(p);

    setLoading(true);
    try {
      let r = await updateMembership(token, membershipFromApi.user_id, p);
    }
    catch (e) {
    }
    setLoading(false);
  }

  function createOrder(data, actions) {
    return actions.order.create({
        purchase_units: [
          {
            amount: {
              value: membresia.costo
            }
          }
        ],
        application_context: {
          shipping_preference: "NO_SHIPPING"
        }
      })
      .then((oId) => {
        setOrderId(oId);
        return oId;
      });
  }

  function onApprove(data, actions) {
    let app = this;
    return actions.order.capture().then(async function (details) {
      console.log(details);
      console.log(`Payment confirmation: ${details?.purchase_units[0]?.payments?.captures[0]?.id}`);

      try {
        await submitMembership(orderId, details?.purchase_units[0]?.payments?.captures[0]?.id);
        setOnApproveMessage(`Transaction completed by ${details.payer.name.given_name}!`);
        gotoPaso(7);
      }
      catch (e) {
        setError('Su cuenta fue creada con éxito y se procesó su pago, pero ocurrió un error evitando que el pago se registrara. No haga el pago de nuevo. El equipo ha sido notificado de este error. El pago será registrado pronto.');
      }
    });
  }

  async function onStripePaymentComplete() {
    try {
      await submitMembership(`${userId}-${Date.now()}`, 'pago-por-stripe');
      setOnApproveMessage(`Tu pago se recibió con éxito!`);
    }
    catch (e) {
      setError('Su cuenta fue creada con éxito y se procesó su pago, pero ocurrió un error evitando que el pago se registrara. No haga el pago de nuevo. El equipo ha sido notificado de este error. El pago será registrado pronto.');
    }
    setPagoCompleted(true);
  }

  function onError(err) {
    setOnErrorMessage(err.toString());
  }

  const regresarBtn = <Col md={3}><Button variant='link' onClick={pasoAnterior}>Regresar</Button></Col>;
  const submitBtn = <Col md={3}><Button key='submit-btn' type='submit' variant='primary'>Continuar</Button></Col>;
  let seccion = '';

  switch (paso) {
    case 0: // Tipo de membresía.
      seccion = 'Elige el tipo de membresía';
      contenido = <Col>
        <p>Si ya fuiste miembro en años anteriores, entonces <Link to={'/login'}>inicia sesión</Link>.</p>
        {membresias.map((m, i) => {
          return <Form.Check type="radio" id={`tipoMembresia${i}`} key={`tipoMembresia${i}`} className='mb-4' >
          <Form.Check.Input type="radio" name='tipoMembresia' className='btn-check' value={m.id} onChange={e => setMembresia(membresias.find(m => m.id === e.target.value))} />
          <Form.Check.Label className='btn btn-dark p-3' >{`${m.label} - $${m.costo}`}</Form.Check.Label>
        </Form.Check>
        })}
      </Col>;
      acciones = <Row className='justify-content-md-end'>
        {membresia && submitBtn}
      </Row>
      break;
    
    case 1: // Perfil.
      let formaPerfil;
      seccion = `Información de perfil (${membresia.label})`;
      switch(membresia.id) {
        case 'matrimonio': formaPerfil = <PerfilMatrimonioForm ref={perfilRef} perfil={perfil} />; break;
        case 'mama': formaPerfil = <PerfilMamaForm ref={perfilRef} perfil={perfil} />; break;
        case 'asesor': formaPerfil = <PerfilAsesorForm ref={perfilRef} perfil={perfil} />; break;
      }
      contenido = <Col>
        {formaPerfil}
      </Col>;
      acciones = <Row className='justify-content-md-end'>
        {regresarBtn}
        {submitBtn}
      </Row>;
      break;
    
    case 2: // Dirección.
      seccion = 'Dirección'
      contenido = <Col>
        <DireccionForm ref={direccionRef} direccion={direccion} />
      </Col>;
      acciones = <Row className='justify-content-md-end'>
        {regresarBtn}
        {submitBtn}
      </Row>;
      break;

    case 3: // Apostolado.
      seccion = 'Apostolado';
      contenido = <Col>
        <p>{onErrorMessage}</p>
        <PerfilApostoladoForm ref={apostoladoRef} apostolado={apostolado} membresia={membresia} />
      </Col>;
      acciones = <Row className='justify-content-md-end'>
        {regresarBtn}
        {submitBtn}
      </Row>;
      break;

    case 4: // Permisos.
      console.log(`consents: ${JSON.stringify(consents)}`);
      seccion = 'Permisos';
      contenido = <Col>
        <p>{onErrorMessage}</p>
        <PerfilPermisosForm ref={consentRef} consents={consents} />
      </Col>;
      acciones = <Row className='justify-content-md-end'>
        {regresarBtn}
        {submitBtn}
      </Row>;
      break;

    case 5: // Información de cuenta.
      seccion = 'Información de tu cuenta';
      contenido = <Col>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control type="email" placeholder="Enter email" value={email} onChange={e => setEmail(e.target.value)} required />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Password</Form.Label>
          <Form.Control type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
        </Form.Group>
    </Col>;
    acciones = <Row className='justify-content-md-end'>
      {regresarBtn}
      {submitBtn}
    </Row>;
    break;

    case 6: // Pago
      const stripeOptions = {
        fetchClientSecret: fetchClientSecret(membresia, email),
        onComplete: onStripePaymentComplete
      };
      seccion = 'Pago';
      contenido = <Col>
        <p>Membresía: {membresia.label}</p>
        <p>Aportación: ${membresia.costo}</p>
        {orderId && <p>Número de órden: {orderId}</p>}
        <p>{onApproveMessage}</p>
        <p>{onErrorMessage}</p>
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={stripeOptions}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </Col>;

      if (pagoCompleted) {
        acciones = <Row className='justify-content-md-end mt-3'>
          <Col md={3}><Link to={'/app'} className='btn btn-primary'>Ir al dashboard</Link></Col>
          <Col md={3}><Button variant='link' onClick={onLogout}>Cerrar sesión</Button></Col>
        </Row>;
      }

      break;

    case 7: // Confirmación de pago.
      seccion = 'Confirmación';
      contenido = <Col>
        <p>Tu pago ha sido recibido.</p>
        <p>Número de orden: {orderId}.</p>
      </Col>;
      acciones = <Row className='justify-content-md-end'>
      <Col md={3}><Link to={'/app'} className='btn btn-primary'>Ir al dashboard</Link></Col>
      <Col md={3}><Button variant='link' onClick={onLogout}>Cerrar sesión</Button></Col>
    </Row>;
    break;

    case 8: // Confirmación de Membresia para asesores espirituales.
      seccion = 'Confirmación';
      contenido = <Col>
        <p>Su membresía ha sido registrada.</p>
      </Col>;
      acciones = <Row className='justify-content-md-end'>
      <Col md={3}><Link to={'/app'} className='btn btn-primary'>Ir al dashboard</Link></Col>
      <Col md={3}><Button variant='link' onClick={onLogout}>Cerrar sesión</Button></Col>
    </Row>;
    break;

    case 9: // Confirmación de Membresia cuando no se aceptaban pagos en linea.
      seccion = 'Confirmación';
      contenido = <Col>
        <p>Su membresía ha sido registrada.</p>
        <p>Un miembro coordinador debe actualizar su cuenta manualmente registrando el pago de la membresía.</p>
      </Col>;
      acciones = <Row className='justify-content-md-end'>
      <Col md={3}><Link to={'/app'} className='btn btn-primary'>Ir al dashboard</Link></Col>
      <Col md={3}><Button variant='link' onClick={onLogout}>Cerrar sesión</Button></Col>
    </Row>;
    break;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    console.log(`on submit. Paso: ${paso}.`);
    if (paso <= 4) {
      siguientePaso();
    }
    else if (paso === 5) {
      const user = {
        perfil,
        membresia,
        direccion,
        apostolado,
        email,
        password
      }
      setLoading('Creando cuenta');
      try {
        let r = await userRegister(user);
        setUserId(r.userId);
        onLogin({ token: r.token, allowedSections: []});
        setError('');
        // setSuccess('Cuenta creada con éxito.');

        if (membresia.profileType === 3) {
          await submitMembership(`${r.userId}-${Date.now()}`, 'asesor-espiritual', r.userId);
          if (r.token) {
            let sections = await getALlowedSections(r.token);
            onLogin({ token: r.token, allowedSections: sections, registration: true });
          }
          gotoPaso(8);
        }
        else {
          // Mientras se implementa el pago en linea vamos a hacer el registro manual.
          // gotoPaso(9);
          siguientePaso();
        }
      }
      catch (e) {
        console.log('Registro, error', e);
        setError(e.message);
      }
      
      setLoading('');
    }
  }

  async function submitMembership(orderId, confirmationId, uId) {
    const lineItems = [{
      productType: 'membresia',
      productId: membresia.productId,
      productPrice: membresia.costo,
      quantity: 1
    }];

    try {
      let r = await submitMembershipOrder(orderId, confirmationId, lineItems, {
        user_id: uId || userId,
        profile_type_id: membresia.profileType,
        region_id: apostolado.region,
        diocesis_id: apostolado.diocesis,
        comunidad_id: apostolado.comunidad,
        etapa_id: apostolado.etapa,
        role: apostolado.role,
        coordinadorEquipo: apostolado.coordinadorEquipo
      });
      console.log('Successfully created membership', r);
      if (r.token) {
        await onCompleteRegistration(r.token);
      } else if (token) {
        let sections = await getALlowedSections(token);
        onLogin({ token: token, allowedSections: sections, registration: true });
      }
    }
    catch(e) {
      console.log('Error registering membership: ', e);
      throw e;
    }
  }

  return (
    <Form className='pt-4 mb-4' onSubmit={handleSubmit}>
      <Row className='justify-content-md-center'>
        <Col md={6}>
          <h1>Registro: {seccion}</h1>
          {/* <p>¿Ya tienes cuenta o ya viviste la formación de FAMA en el pasado? <Link to={'/login'}>Inicia Sesión</Link>.</p> */}
          { contenido }
          { acciones }
          { loading && <Loading text={loading} />}
        </Col>
      </Row>
    </Form>
  );
}

export default Registro;
